<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1 style="font-family:Calisto MT; font-size:18pt; letter-spacing:1px; padding-top:75px; padding-bottom:15px;">About the Author</h1>
<p>Esta Finch lived in an icy desert of a place, surrounded by miners and mountaineers. The men of the wild impressed her. The men of Australia, too heavy on the fortune and light on the masculinity, did not. The trepidation with which men goggled at the ladies about them but refused so much as a decent hello bothered her, particularly given how many exceptional ladies there are out there. Esta is no writer, but she is a traveller and purveyor of men and their relations with the fairer sex. The question she has is, can they rediscover themselves in the face of the female?</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?168e2ab1